import { Agent, Channel } from '@nemuru-eng/js-api-client';
import { generatePath } from 'react-router-dom';

import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';

import { useScreen } from '../../../../../../../../hooks/useScreen';
import { DYNAMIC_PAGE_PATHS } from '../../../../../../../views/DynamicPageView/config/shared/pathRoutes';
import { ChannelCard } from '../../../StructureCard/ChannelCard';

interface ChannelListProps {
  agentSearchTerm: string;
  merchantId: string;
  channels: Channel[];
  selectedChannelKey: number | undefined;
  selectChannel: (key: number) => void;
  agentFoundBySearch?: Agent;
  isChannelRedirectAllowed?: boolean;
  page: number;
  rowsPerPage: number;
}

export const ChannelList = ({
  agentSearchTerm,
  merchantId,
  channels,
  selectedChannelKey,
  selectChannel,
  agentFoundBySearch,
  isChannelRedirectAllowed,
  page,
  rowsPerPage,
}: ChannelListProps) => {
  const { isMobile } = useScreen();

  const redirectPath = (channelId: string) =>
    generatePath(DYNAMIC_PAGE_PATHS.CHANNEL, {
      merchantId: merchantId,
      channelId,
    });

  return (
    <>
      {channels.length === 0 ? (
        <PendingDataWarning tId={'THERE_ARE_NO_CHANNELS_FOUND_BY_SEARCH_PARAMS'} />
      ) : (
        channels
          .filter((channel, index) => {
            if (!(!agentFoundBySearch && agentSearchTerm)) return channel;
            if (index + rowsPerPage * (page - 1) === selectedChannelKey) return channel;
          })
          .map((channel, index) => {
            const channelContainsAgent = agentFoundBySearch
              ? channel.agents.some((a) => a.id === agentFoundBySearch.id)
              : false;
            const isSelected = agentFoundBySearch
              ? channelContainsAgent
              : index + rowsPerPage * (page - 1) === selectedChannelKey;
            return (
              <ChannelCard
                key={channel.id}
                channel={channel}
                isSelected={isSelected}
                selectChannel={selectChannel}
                redirectPath={isChannelRedirectAllowed ? redirectPath(channel.id) : undefined}
                index={index + rowsPerPage * (page - 1)}
                isMobile={isMobile}
              />
            );
          })
      )}
    </>
  );
};
